import React, { useContext } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import BtxSwitch from '../../../../../../Forms/BtxSwitch';
import { PermissionsContext } from '../PracticeConversions';
import { actions } from '../../../../../../../context';

const SupportTile = ({ conversion }) => {
    const dispatch = useDispatch();

    const { canManageConversions } = useContext(PermissionsContext);

    const allPims = useSelector(
        (state) => state.pims.allPims,
        allPimsEqualityCheck
    );

    const setActionConversion = (conversion = {}) =>
        dispatch(actions.conversions.setModalConversion(conversion));

    const setIsEditConversionPimsModalOpen = (bool) =>
        dispatch(actions.toggle.toggleEditConversionPimsModalOpen(bool));

    const setIsResetConversionModalOopen = (bool) =>
        dispatch(actions.toggle.toggleResetConversionModalOpen(bool));

    // TODO: pass these functions in as props?
    const resetConversion = (conversion) => {
        setActionConversion(conversion);
        setIsResetConversionModalOopen(true);
    };

    const updateConvertAttachments = ({ id, flag }) => {
        dispatch(
            actions.conversions.updateConvertAttachments({ id, flag })
        ).then(() => {
            // TODO: implement optimistic update instead of a forced refresh
            dispatch(actions.toggle.triggerPracticeRefresh());
            dispatch(actions.toggle.activitiesRefresh());
        });
    };

    return (
        <Col lg="4" className="py-2">
            <Row className="h-100">
                <Col
                    lg="11"
                    sm="12"
                    className="mx-auto sc-shadow sc-glass rounded text-light py-2 bg-dark-opacity-">
                    <Row className="border-bottom border-light text-center hide-overflow">
                        <Col lg="12">
                            <h3>Details</h3>
                        </Col>
                    </Row>
                    <Row className="d-flex flex-wrap justify-content-center text-left">
                        {canManageConversions && (
                            <>
                                <Col xs={labelWidth} className={labelClass}>
                                    Partner
                                </Col>
                                <Col xs={valueWidth} className={valueClass}>
                                    {conversion.partner}
                                </Col>
                                {conversion.sourcePims && (
                                    <>
                                        <Col
                                            xs={labelWidth}
                                            className={labelClass}>
                                            Source PIMS
                                        </Col>
                                        <Col
                                            xs={valueWidth}
                                            className={valueClass}>
                                            {conversion?.isComplete ? (
                                                displayPimsName(
                                                    conversion,
                                                    allPims
                                                )
                                            ) : (
                                                <Button
                                                    color="link"
                                                    className="p-0 text-white"
                                                    onClick={() => {
                                                        setActionConversion(
                                                            conversion
                                                        );
                                                        setIsEditConversionPimsModalOpen(
                                                            true
                                                        );
                                                    }}>
                                                    {displayPimsName(
                                                        conversion,
                                                        allPims
                                                    )}
                                                </Button>
                                            )}
                                        </Col>
                                    </>
                                )}
                            </>
                        )}
                        <Col xs={labelWidth} className={labelClass}>
                            Status
                        </Col>
                        <Col
                            xs={valueWidth}
                            className={`${valueClass} text-nowrap`}>
                            {getConversionStatusText(conversion)}
                            {conversion.isComplete && (
                                <>
                                    &emsp;
                                    <FontAwesomeIcon
                                        icon={faCheck}
                                        className="text-light"
                                    />
                                </>
                            )}
                        </Col>
                        <Col xs={labelWidth} className={labelClass}>
                            <div className="pt-2">Convert Attachments</div>
                        </Col>
                        <Col xs={valueWidth} className={valueClass}>
                            <BtxSwitch
                                value={conversion?.convertAttachments}
                                disabled={conversion?.isComplete}
                                onChange={() =>
                                    updateConvertAttachments({
                                        id: conversion.id,
                                        flag: !conversion?.convertAttachments,
                                    })
                                }
                            />
                        </Col>
                        <Col xs={labelWidth} className={labelClass}>
                            {conversion.isComplete && <>Completed</>}
                        </Col>
                        <Col xs={valueWidth} className={valueClass}>
                            {conversion.isComplete && (
                                <>
                                    {moment
                                        .unix(conversion.dateCompleted)
                                        .format('MMM D, YYYY h:mm a')}
                                </>
                            )}
                        </Col>
                        <Col xs={labelWidth} className={labelClass}>
                            {conversion.isComplete && <>Data Available Until</>}
                        </Col>
                        <Col xs={valueWidth} className={valueClass}>
                            {conversion.isComplete && (
                                <>
                                    {moment
                                        .unix(conversion.supportEndDate)
                                        .format('MMM D, YYYY')}
                                </>
                            )}
                        </Col>
                        {canManageConversions && (
                            <Col>
                                <Button
                                    color="link"
                                    className="p-0 text-white"
                                    onClick={() => resetConversion(conversion)}>
                                    Reset Conversion
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        </Col>
    );
};
//milestone classes
const commonClasses = `text-wrap d-inline py-2 px-4`;
const labelClass = `${commonClasses}`;
const valueClass = `text-right ${commonClasses}`;

const labelWidth = 6;
const valueWidth = 6;

const displayPimsName = (conversion, allPims) => {
    var pimsName = (allPims || []).filter(
        (p) => p.id === conversion.sourcePims
    )?.[0]?.name;

    if (conversion.sourcePimsName)
        pimsName += ` (${conversion.sourcePimsName})`;
    return pimsName;
};
const isMilestoneInProgress = (milestone) =>
    milestone.dataGathered ||
    milestone.conversionCompleted ||
    milestone.qaCompleted ||
    milestone.delivered;

const getConversionStatusText = (conversion) => {
    if (conversion?.isComplete) return `Complete`;
    if (
        isMilestoneInProgress(conversion?.trial) ||
        isMilestoneInProgress(conversion?.final)
    )
        return `In-Progress`;
    return `New`;
};
// TODO: explore putting all equality functions into a standardized location
// would need a way to tweak equality to only the needs of the requesting component
// would want to enforce app wide equlity concerns in the localized equlity corral
// Ie: what field on pims would affect conversions even if not used in UI? Enfore that on back-end only?
// TODO: evaluate the performance of different equlaity function approaches
// ie: creat Map or Set with ID fields, Object.assign vs spread, .find or .every vs other methods
const allPimsEqualityCheck = (newPimsList, oldPimsList) => {
    if (oldPimsList.length !== newPimsList.length) return false;
    const pimsEqualityCheck = (oldPims) => {
        const template = {
            id: '',
            name: '',
        };
        const oldState = Object.assign(
            {},
            template,
            ...Object.keys(template).map(
                (k) => k in oldPims && { [k]: oldPims[k] }
            )
        );

        const comparePims = (newPims) => {
            const newState = Object.assign(
                {},
                template,
                ...Object.keys(template).map(
                    (k) => k in newPims && { [k]: newPims[k] }
                )
            );
            return shallowEqual(oldState, newState);
        };
        const check = newPimsList.find(comparePims);
        return check !== undefined;
    };
    const comparedPimsList =
        !!oldPimsList.length && oldPimsList.every(pimsEqualityCheck);

    const isSamePimsList = !!newPimsList.length && comparedPimsList;

    return isSamePimsList;
};

export default SupportTile;
